import React from 'react';
import { motion } from 'framer-motion';
import { Crown, User, Mail, Lock, Sparkles, ArrowRight } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const Register = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#fdfdfd] relative overflow-hidden">
      <div className="absolute inset-0 luxury-grid-bg pointer-events-none" />
      
      {/* Decorative Elements */}
      <div className="absolute top-[10%] right-[10%] w-64 h-64 border border-black/[0.03] rounded-full pointer-events-none" />
      <div className="absolute bottom-[10%] left-[10%] w-96 h-96 border border-black/[0.03] rounded-full pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="luxury-card w-full max-w-lg p-12 relative z-10"
      >
        <div className="text-center mb-12">
          <div className="flex justify-center gap-4 mb-6">
            <div className="w-12 h-[1px] bg-black/[0.05] mt-6" />
            <Crown size={32} className="text-black" strokeWidth={1} />
            <div className="w-12 h-[1px] bg-black/[0.05] mt-6" />
          </div>
          <h1 className="text-3xl font-serif text-black mb-3">Join the Elite</h1>
          <p className="text-[#999] text-[10px] font-bold uppercase tracking-[0.4em]">Membership Application</p>
        </div>

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-1">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-widest ml-4">First Name</label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ccc]" size={14} />
              <input type="text" placeholder="Aria" className="w-full bg-black/[0.02] border border-black/[0.05] rounded-2xl py-3.5 pl-10 pr-6 text-xs text-black focus:outline-none focus:border-black/10 transition-all placeholder-black/20" />
            </div>
          </div>

          <div className="space-y-1">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-widest ml-4">Last Name</label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ccc]" size={14} />
              <input type="text" placeholder="Sterling" className="w-full bg-black/[0.02] border border-black/[0.05] rounded-2xl py-3.5 pl-10 pr-6 text-xs text-black focus:outline-none focus:border-black/10 transition-all placeholder-black/20" />
            </div>
          </div>

          <div className="md:col-span-2 space-y-1">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-widest ml-4">Email Address</label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ccc]" size={14} />
              <input type="email" placeholder="aria@luxury.com" className="w-full bg-black/[0.02] border border-black/[0.05] rounded-2xl py-3.5 pl-10 pr-6 text-xs text-black focus:outline-none focus:border-black/10 transition-all placeholder-black/20" />
            </div>
          </div>

          <div className="md:col-span-2 space-y-1">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-widest ml-4">Security Phrase</label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-[#ccc]" size={14} />
              <input type="password" placeholder="••••••••" className="w-full bg-black/[0.02] border border-black/[0.05] rounded-2xl py-3.5 pl-10 pr-6 text-xs text-black focus:outline-none focus:border-black/10 transition-all placeholder-black/20" />
            </div>
          </div>

          <div className="md:col-span-2 flex items-center gap-3 px-2 py-4">
            <input type="checkbox" className="w-4 h-4 accent-black bg-black/[0.02] border-black/[0.05] rounded" />
            <p className="text-[9px] text-[#999] font-bold uppercase tracking-widest leading-relaxed">
              I agree to the <span className="text-black cursor-pointer hover:underline font-black">Terms of Elegance</span> and <span className="text-black cursor-pointer hover:underline font-black">Privilege Protocols</span>.
            </p>
          </div>

          <motion.button
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            type="button"
            onClick={() => navigate('/admin/dashboard')}
            className="md:col-span-2 luxury-button flex items-center justify-center gap-3 !py-4 shadow-2xl"
          >
            Create My Account
            <ArrowRight size={16} />
          </motion.button>
        </form>

        <p className="mt-12 text-center text-[10px] font-bold text-[#999] uppercase tracking-widest">
          Already a member? <Link to="/shopowner" className="text-black font-black hover:underline">Sign In</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default Register;
